export default "<spec-app-type7-time-table #table [clickHandler]=\"clickHandler\" [allowCreate]=\"true\"></spec-app-type7-time-table>\n";